import React, { useEffect, useState } from 'react'

import { useSelector } from 'react-redux'

import type { MenuPreferences } from '@library/api-menu-experience'

import { useMenuMeta } from 'hooks/menu-metadata/useMenuMeta'
import { useRecipeTileRefresh } from 'routes/Menu/hooks/useRecipeTileRefresh'
import { getBasketDate } from 'selectors/basket'

import { RecipeList } from '../../../MenuRecipesPage/RecipeList'
import { DetailOverlay } from '../../../components/Detail'

type RecipeGridProps = {
  menuPreferences?: MenuPreferences
}

export const RecipeGrid = ({ menuPreferences }: RecipeGridProps) => {
  const [shouldShowOverlay, setShouldShowOverlay] = useState(false)
  const { menuId } = useMenuMeta()
  const deliveryDate = useSelector(getBasketDate)
  const { refreshRecipeTile } = useRecipeTileRefresh({
    deliveryDate,
    menuId,
  })

  useEffect(() => {
    setShouldShowOverlay(true)
  }, [])

  return (
    <div data-testid="menuRecipesList">
      <RecipeList menuPreferences={menuPreferences} refreshRecipeTile={refreshRecipeTile} />
      <DetailOverlay showOverlay={shouldShowOverlay} refreshRecipeTile={refreshRecipeTile} />
    </div>
  )
}
